import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(private http: HttpClient) { }

  searchByMemberName(name) {
    return this.http.get(env.server + '/members/by-member-name/' + name);
  }

  searchByLastName(tourName) {
    return this.http.get(env.server + '/members/by-member-lastName/' + tourName);
  }
  
  searchByMemberNumber(memberNumber) {
    return this.http.get(env.server + '/members/all-by-member-number/' + memberNumber);
  }

  confirmIHT(member) {
    return this.http.post(env.mongoURL + '/members/populate-iht', member, {
      headers: {
        'mss-key': env.mssKey
      }
    });
  }

  searchMemberByTourId(tourId) {
    return this.http.get(env.server + '/members/byOrderId/' + tourId);
  } 

  searchByHopNumber(hopNumber) {
    return this.http.get(env.server + '/members/by-hop/' + hopNumber)
  }

  activateRefinance(payload) {
    return this.http.post(env.server + '/members/activate-refi-cashout', payload).toPromise();
  }

}
